/**
 * Ask before the tab closes while `active` — for work that lives only in this tab
 * (a background create, a queued submit) and would be abandoned with no record.
 *
 * Deliberately free of React Query, so a component can use it without a
 * QueryClientProvider above it.
 *
 * @module hooks/core/useWarnBeforeUnload
 */
import { useEffect } from 'react';

export function useWarnBeforeUnload(active: boolean): void {
  useEffect(() => {
    if (!active) return undefined;
    const warn = (e: BeforeUnloadEvent) => {
      e.preventDefault();
      // Chrome still requires returnValue to be set for the prompt to show.
      e.returnValue = '';
    };
    window.addEventListener('beforeunload', warn);
    return () => window.removeEventListener('beforeunload', warn);
  }, [active]);
}
